"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var User = /*#__PURE__*/function () {
  function User(client) {
    (0, _classCallCheck2["default"])(this, User);
    this.client = client;
    this.resourceUrl = '/user';
  }

  (0, _createClass2["default"])(User, [{
    key: "getProfile",
    value: function getProfile(id) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(id), args);
    }
  }, {
    key: "updateProfile",
    value: function updateProfile(data, id) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(id, "/update-profile"), data, args);
    }
  }, {
    key: "updatePassword",
    value: function updatePassword(data, id) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(id, "/update-password"), data, args);
    }
  }, {
    key: "submitHelp",
    value: function submitHelp(data) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.post("".concat(this.resourceUrl, "/help"), data, args);
    }
  }, {
    key: "needPlanUpgrade",
    value: function needPlanUpgrade(params) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      return this.client.get("".concat(this.resourceUrl, "/need-upgrade").concat(params), args);
    }
  }, {
    key: "acceptCookie",
    value: function acceptCookie(data, userId) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(userId, "/cookies"), data, args);
    }
  }, {
    key: "getUserPriviliges",
    value: function getUserPriviliges() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return this.client.get("".concat(this.resourceUrl, "/user-priviliges"), args);
    }
  }, {
    key: "getUserJourney",
    value: function getUserJourney(_ref) {
      var _this$client;

      var clientId = _ref.clientId,
          tabType = _ref.tabType;
      var url = '/journey';

      if (clientId) {
        url += "?clientId=".concat(clientId);
      }

      if (tabType) {
        url += "?tabType=".concat(tabType);
      }

      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      return (_this$client = this.client).get.apply(_this$client, [url].concat(args));
    }
  }, {
    key: "getUserNotifications",
    value: function getUserNotifications() {
      var _this$client2;

      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      return (_this$client2 = this.client).get.apply(_this$client2, ['/notification'].concat(args));
    }
  }, {
    key: "getUserNotificationCount",
    value: function getUserNotificationCount() {
      var _this$client3;

      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }

      return (_this$client3 = this.client).get.apply(_this$client3, ['/notification/count'].concat(args));
    }
  }, {
    key: "hasNotificationRead",
    value: function hasNotificationRead(data) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }

      return this.client.post('/notification/read', data, args);
    }
  }, {
    key: "switchToFreePlan",
    value: function switchToFreePlan() {
      for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        args[_key12] = arguments[_key12];
      }

      return this.client.put("/user/plan/free", args);
    }
  }, {
    key: "getEnrollProgramDetails",
    value: function getEnrollProgramDetails() {
      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        args[_key13] = arguments[_key13];
      }

      return this.client.get("".concat(this.resourceUrl, "/network-program"), args);
    }
  }, {
    key: "getUserAddress",
    value: function getUserAddress(userId) {
      for (var _len14 = arguments.length, args = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
        args[_key14 - 1] = arguments[_key14];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(userId, "/billing-info"), args);
    }
  }, {
    key: "getRecentFavorites",
    value: function getRecentFavorites() {
      for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
        args[_key15] = arguments[_key15];
      }

      return this.client.get("".concat(this.resourceUrl, "/recent-favorites"), args);
    }
  }, {
    key: "getRecentIntentions",
    value: function getRecentIntentions() {
      for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
        args[_key16] = arguments[_key16];
      }

      return this.client.get("".concat(this.resourceUrl, "/recent-intentions"), args);
    }
  }, {
    key: "getRecentSessions",
    value: function getRecentSessions() {
      for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
        args[_key17] = arguments[_key17];
      }

      return this.client.get("".concat(this.resourceUrl, "/recent-sessions"), args);
    }
  }, {
    key: "checkGrowthPlanScheduled",
    value: function checkGrowthPlanScheduled() {
      for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
        args[_key18] = arguments[_key18];
      }

      return this.client.get("".concat(this.resourceUrl, "/check-growth-coach-assignment-scheduled"), args);
    }
  }, {
    key: "getRecentSurveyMiniResult",
    value: function getRecentSurveyMiniResult() {
      for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
        args[_key19] = arguments[_key19];
      }

      return this.client.get("".concat(this.resourceUrl, "/recent-survey"), args);
    }
  }, {
    key: "getFavoriteCategories",
    value: function getFavoriteCategories() {
      for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
        args[_key20] = arguments[_key20];
      }

      return this.client.get("".concat(this.resourceUrl, "/favorites-category"), args);
    }
  }, {
    key: "upgradePlan",
    value: function upgradePlan(data) {
      for (var _len21 = arguments.length, args = new Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
        args[_key21 - 1] = arguments[_key21];
      }

      return this.client.post("".concat(this.resourceUrl, "/upgrade-plan"), data, args);
    }
  }]);
  return User;
}();

exports["default"] = User;